/**
 * Icon set — SVG inline. Migrado de design_prototipo/.../components/icons.jsx
 * con TS typing. Las helpers JS del prototipo (cómputo de dosis) NO se migran:
 * Drimian P6 obliga a que la dosificación viva en backend.
 */
import type { SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement>

const baseProps: Partial<IconProps> = {
  width: 18,
  height: 18,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
}

export const Icon = {
  Send: (p: IconProps = {}) => (
    <svg {...baseProps} {...p}>
      <path d="M22 2L11 13" />
      <path d="M22 2l-7 20-4-9-9-4 20-7z" />
    </svg>
  ),
  Search: (p: IconProps = {}) => (
    <svg {...baseProps} {...p}>
      <circle cx="11" cy="11" r="7" />
      <path d="M21 21l-4.35-4.35" />
    </svg>
  ),
  Plus: (p: IconProps = {}) => (
    <svg {...baseProps} strokeWidth={2.5} {...p}>
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  ),
  Close: (p: IconProps = {}) => (
    <svg {...baseProps} {...p}>
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="18" x2="18" y2="6" />
    </svg>
  ),
  Check: (p: IconProps = {}) => (
    <svg {...baseProps} strokeWidth={3} {...p}>
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
  Print: (p: IconProps = {}) => (
    <svg {...baseProps} {...p}>
      <path d="M6 9V2h12v7M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2" />
      <rect x="6" y="14" width="12" height="8" />
    </svg>
  ),
  Pill: (p: IconProps = {}) => (
    <svg {...baseProps} {...p}>
      <path d="M10.5 20.5L3.5 13.5a4.95 4.95 0 010-7 4.95 4.95 0 017 0l7 7a4.95 4.95 0 010 7 4.95 4.95 0 01-7 0z" />
      <path d="M8.5 8.5l7 7" />
    </svg>
  ),
  Shuffle: (p: IconProps = {}) => (
    <svg {...baseProps} {...p}>
      <polyline points="16 3 21 3 21 8" />
      <line x1="4" y1="20" x2="21" y2="3" />
      <polyline points="21 16 21 21 16 21" />
      <line x1="15" y1="15" x2="21" y2="21" />
      <line x1="4" y1="4" x2="9" y2="9" />
    </svg>
  ),
  Alert: (p: IconProps = {}) => (
    <svg {...baseProps} {...p}>
      <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  Chev: (p: IconProps = {}) => (
    <svg {...baseProps} {...p}>
      <polyline points="9 18 15 12 9 6" />
    </svg>
  ),
  Rx: (p: IconProps = {}) => (
    <svg {...baseProps} {...p}>
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="9" y1="15" x2="15" y2="15" />
      <line x1="9" y1="11" x2="15" y2="11" />
    </svg>
  ),
  Info: (p: IconProps = {}) => (
    <svg {...baseProps} {...p}>
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="16" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12.01" y2="8" />
    </svg>
  ),
  // 2026-10-20 — en lugar de emoji (cada tablet los dibuja distinto y el lector los lee "hombre")
  Adulto: (p: IconProps = {}) => (
    <svg {...baseProps} {...p}>
      <circle cx="12" cy="7" r="4" />
      <path d="M5 21a7 7 0 0114 0" />
    </svg>
  ),
  Nino: (p: IconProps = {}) => (
    <svg {...baseProps} {...p}>
      <circle cx="12" cy="12" r="9" />
      <path d="M8.5 14.5a4 4 0 007 0" />
      <line x1="9" y1="9.5" x2="9.01" y2="9.5" />
      <line x1="15" y1="9.5" x2="15.01" y2="9.5" />
    </svg>
  ),
  Embarazo: (p: IconProps = {}) => (
    <svg {...baseProps} {...p}>
      <circle cx="10" cy="4.5" r="2.5" />
      <path d="M10 8v13" />
      <path d="M10 10c4 0 6 2.5 6 5s-2.5 4-6 4" />
    </svg>
  ),
  Lactancia: (p: IconProps = {}) => (
    <svg {...baseProps} {...p}>
      <path d="M9 2h6" />
      <path d="M10 2v3l-2 3v12a2 2 0 002 2h4a2 2 0 002-2V8l-2-3V2" />
      <line x1="8" y1="12" x2="16" y2="12" />
    </svg>
  ),
  Stop: (p: IconProps = {}) => (
    <svg {...baseProps} {...p}>
      <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2" />
      <line x1="15" y1="9" x2="9" y2="15" />
      <line x1="9" y1="9" x2="15" y2="15" />
    </svg>
  ),
  Plus2: (p: IconProps = {}) => (
    <svg {...baseProps} {...p}>
      <rect x="3" y="3" width="18" height="18" rx="4" />
      <path d="M12 8v8M8 12h8" />
    </svg>
  ),
  Barras: (p: IconProps = {}) => (
    <svg {...baseProps} {...p}>
      <path d="M3 7V5a2 2 0 012-2h2M17 3h2a2 2 0 012 2v2M21 17v2a2 2 0 01-2 2h-2M7 21H5a2 2 0 01-2-2v-2" />
      <line x1="7" y1="8" x2="7" y2="16" />
      <line x1="10" y1="8" x2="10" y2="16" />
      <line x1="13" y1="8" x2="13" y2="16" />
      <line x1="17" y1="8" x2="17" y2="16" />
    </svg>
  ),
  Mic: (p: IconProps = {}) => (
    <svg {...baseProps} {...p}>
      <rect x="9" y="2" width="6" height="12" rx="3" />
      <path d="M5 10v1a7 7 0 0014 0v-1" />
      <line x1="12" y1="18" x2="12" y2="22" />
    </svg>
  ),
  Clock: (p: IconProps = {}) => (
    <svg {...baseProps} {...p}>
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  ),
}
